module.exports = __webpack_public_path__ + "static/img/xfzzxfw.64efe1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/xfzzxfw.jpg
// module id = 5ozO
// module chunks = 21